import React from 'react';
import { connect } from 'react-redux';

import Header from '../Header';
import styles from './PurchasedStaffSlots.css';

class PurchasedStaffSlots extends React.Component {
  render() {
    const { showLoadingSpinnerPage, purchasedStaffs } = this.props;
    return (
      !showLoadingSpinnerPage &&
      purchasedStaffs.length > 0 && (
        <div>
          <Header title="Extendable Purchased Slots" />
          <div className={styles['row-wrapper']}>
            <div className={styles['text-title']}>
              Number of Extendable Purchased Slots
            </div>
            <div className={styles['text-number']}>
              {purchasedStaffs.length} Slots
            </div>
          </div>
        </div>
      )
    );
  }
}

function mapStateToProps(state) {
  const { showLoadingSpinnerPage } = state.loadingSpinner;
  const { purchasedStaffs } = state.setting.billing;
  return {
    showLoadingSpinnerPage,
    purchasedStaffs,
  };
}

export default connect(mapStateToProps)(PurchasedStaffSlots);
